import { render, staticRenderFns } from "./coBank.vue?vue&type=template&id=6c3c7607&scoped=true"
import script from "./coBank.vue?vue&type=script&lang=js"
export * from "./coBank.vue?vue&type=script&lang=js"
import style0 from "./coBank.vue?vue&type=style&index=0&id=6c3c7607&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c3c7607",
  null
  
)

export default component.exports